import gql from "graphql-tag"

export default gql`
  fragment renewalOption on RenewalOption {
    termLength
    costPerSeatMonth
    isDefault
    annualCost
    discount
    annualSaving
    costPerSeatMonth4Dp
  }
`
